var render = function render(){var _vm=this,_c=_vm._self._c;return _c('collect-list-component',{attrs:{"collect-type":'userCollect',"default-filter":{uuid:_vm.memberKey}}})
}
var staticRenderFns = []

export { render, staticRenderFns }